module.exports = __webpack_public_path__ + "media/images/badge-draft-ca4b3581ba4735442749c0203f506db8.svg";